/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */
import { assign } from 'lodash';
import { isValid, parseISO } from 'date-fns';

export abstract class JSONable {

  private static reviveDates(json: any) {
    const string = JSON.stringify(json);
    return JSON.parse(string, (_key, value) => {
      if (typeof value === 'string') {
        const dateFnsDate = parseISO(value);
        if (isValid(dateFnsDate)) {
          return dateFnsDate;
        }
      }
      return value;
    });
  }

  fromJSON?(json: any): void {
    assign(this, json);
  }
}
